import {
  SignTextDeviceStrategy,
  SignTextFileSystemStrategy,
  SignTextDepositSignLoginPswStrategy,
  SignTextDiiaStrategy,
  SignTextCloudKeyFileSystemStrategy,
  SignTextWithQrCloudProviderStrategy,
  SignTextWithIdCloudProviderStrategy
} from '@/sign/strategies/sign-text-private-key.strategy';
import { SignStrategyFactory } from './sign-strategy.factory';

export class SignTextStrategyFactory extends SignStrategyFactory {
  constructor() {
    super(
      SignTextFileSystemStrategy,
      SignTextDeviceStrategy,
      SignTextDepositSignLoginPswStrategy,
      SignTextDiiaStrategy,
      SignTextCloudKeyFileSystemStrategy,
      SignTextWithQrCloudProviderStrategy,
      SignTextWithIdCloudProviderStrategy);
  }
}
